import { createSlice } from '@reduxjs/toolkit';
import { IndicatorOrLaw, SearchInformation } from '../../../../interfaces/Indicator';
import { getIndicators } from './indicatorThunk';
import { Pagination } from '../../../../interfaces/Pagination';

interface SearchMetaData extends SearchInformation {
    terms: string[]
}

interface IndicatorDisplay {
    loading: "idle" | "pending" | "succeeded" | "failed";
    indicators: IndicatorOrLaw[] | null;
    errors_indicators: boolean | undefined;
    pagination: Pagination;
    fileExists: boolean;
    searchMetadata: SearchMetaData | null;
}

const initialState: IndicatorDisplay = {
    loading: 'idle',
    indicators: null,
    errors_indicators: false,
    pagination: { totalItems: 0, currentPage: 1, pageSize: 5, totalPages: 0 },
    fileExists: false,
    searchMetadata: null
}

export const indicatorSlice = createSlice({
    name: 'indicator_display',
    initialState,
    reducers: {
        clearIndicators: (state) => {
            state.indicators = [];
            state.pagination = { totalItems: 0, currentPage: 1, pageSize: 5, totalPages: 0 };
            state.errors_indicators = false;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(getIndicators.pending, (state) => {
            state.loading = "pending";
        });
        builder.addCase(getIndicators.fulfilled, (state, action) => {
            state.loading = "succeeded";
            state.indicators = action.payload.indicator;
            state.pagination = action.payload.pagination;
            state.errors_indicators = action.payload.error;
            let searchMetaData = action.payload.searchMeta;

            state.searchMetadata = searchMetaData
                ? {
                    terms: [searchMetaData.originalSearch, ...searchMetaData.synonymsUsed],
                    originalSearch: searchMetaData.originalSearch,
                    synonymsUsed: searchMetaData.synonymsUsed,
                    activeSynonyms: searchMetaData.activeSynonyms
                }
                : null;
        });
        builder.addCase(getIndicators.rejected, (state) => {
            state.loading = "failed";
            state.errors_indicators = true
        });
    }
})

export const { clearIndicators } = indicatorSlice.actions;
export default indicatorSlice.reducer;